import React from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// COMPONENTS
import ListItem from './TariffLineTableRow';
import Loader from '../../../../common/Loader';

const TariffLineTable = ({
  tariffLines = [],
  addNewTariffLine,
  showSingleTariffLine,
  isLoading = false,
}) => {
  const handleAddNewTariffLineClick = () => {
    if (typeof addNewTariffLine === 'function') {
      showSingleTariffLine();
      addNewTariffLine();
    } else {
      console.log('addNewTariffLine is not a function:', addNewTariffLine);
    }
  };
  if (isLoading) {
    return <Loader />;
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography variant="h2">List of Tariff Lines</Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleAddNewTariffLineClick()}
        >
          Add New
        </Button>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tariff Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Unit</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Period</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Batches</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tariffLines.map((line) => (
              <ListItem
                key={line.tariff_line_id}
                id={line.tariff_line_id}
                lineName={line.tariff_name}
                lineType={line.tariff_type_name}
                lineRate={line.rate}
                lineUnit={line.unit_name}
                lineCategory={line.category_name}
                linePeriod={line.period_name}
                lineQuantity={line.quantity}
                lineBatches={line.batches}
                line={line}
                onClickName={() => {
                  showSingleTariffLine(line);
                }}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TariffLineTable;
